import {
  Box,
  ClickOutside,
  CsvFilelconIcon,
  GKButton,
  IconButton,
  Popper,
  ZipFileIcon,
} from "components";
import { useMutation } from "hooks/useQueries";
import React, { useState } from "react";
import axiosInstance from "utils/axiosInstance";
import { handleDowloadFile } from "utils/fileHelper";
import PreTradeConfirmationModal from "./PreTradeConfirmationModal";

interface Props {
  item: any;
  type: string[];
  icon: any;
}

const OrderPopOverActions = ({ item, type, icon }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [downloadName, setDownloadName] = useState("");
  const [orderId, setOrderId] = useState();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [sendEmailType, setSendEmailType] = useState("");

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const { mutate: DownloadZIP } = useMutation({
    mutationFn: (data: any) => {
      setDownloadName(data?.name);
      return axiosInstance.get(
        `/model_portfolio/${data?.modelPortfolioId}/download-clients-zip/?order=${data?.orderId}`,
        { responseType: "arraybuffer" },
      );
    },
    retry: false,
    onSuccess: (data: any) => {
      handleDowloadFile({
        fileData: data?.data,
        applicaionType: "application/zip",
        fileName: downloadName,
        extensionType: "zip",
      });
    },
  });

  const { mutate: DownloadCSV } = useMutation({
    mutationFn: (data: any) => {
      setDownloadName(data?.name);
      return axiosInstance.get(
        `/model_portfolio/${data?.modelPortfolioId}/order-download/?order=${data?.orderId}`,
      );
    },
    retry: false,
    onSuccess: (data: any) => {
      handleDowloadFile({
        fileData: data?.data,
        applicaionType: "text/csv",
        fileName: downloadName,
        extensionType: "csv",
      });
    },
  });

  return (
    <>
      <IconButton onClick={handleClick}>{icon}</IconButton>

      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ zIndex: 4, width: 180 }}
      >
        <ClickOutside onClose={() => setAnchorEl(null)}>
          <Box
            sx={{
              border: `solid 1px var(--neutral-100)`,
              borderRadius: "10px",
              boxShadow: `0px 0px 5px 4px var(--primary-50)`,
              p: 1,
              bgcolor: "background.paper",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {type.includes("ZIP") && (
              <GKButton
                sx={{ color: "#333" }}
                startIcon={<ZipFileIcon />}
                onClick={() => {
                  DownloadZIP({
                    orderId: item.id,
                    modelPortfolioId: item.modelPortfolioId,
                    name: `${item.orderTemplate}`,
                  });
                }}
              >
                Download as Zip
              </GKButton>
            )}

            {type.includes("CSV") && (
              <GKButton
                sx={{ color: "#333" }}
                startIcon={<CsvFilelconIcon />}
                onClick={() => {
                  DownloadCSV({
                    orderId: item.id,
                    modelPortfolioId: item.modelPortfolioId,
                    name: `${item.orderTemplate}`,
                  });
                }}
              >
                Download as CSV
              </GKButton>
            )}

            {type.includes("TRADE") && (
              <GKButton
                sx={{ color: "#333" }}
                onClick={() => {
                  setOrderId(item.id);
                  setSendEmailType("TRADE");
                  setConfirmationModal(true);
                }}
              >
                Send Order Sheet
              </GKButton>
            )}

            {type.includes("ORDER") && (
              <GKButton
                sx={{ color: "#333" }}
                onClick={() => {
                  setOrderId(item.id);
                  setSendEmailType("ORDER");
                  setConfirmationModal(true);
                }}
              >
                Send for Execution
              </GKButton>
            )}
          </Box>
        </ClickOutside>
      </Popper>

      {confirmationModal && (
        <PreTradeConfirmationModal
          open={confirmationModal}
          setOpen={setConfirmationModal}
          orderId={orderId}
          sendEmailType={sendEmailType}
        />
      )}
    </>
  );
};

export default OrderPopOverActions;
